module.exports = __webpack_public_path__ + "img/wangrui.59b818ba.png";